const container = document.getElementById('webanim20');
if ('IntersectionObserver' in window) {
	new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				import(/* webpackPreload: true */ './webanim20-defer');
				observer.unobserve(entry.target);
			}
		});
	}).observe(container);
}
